import React from 'react';
import PdfPreviewLogin from 'components/pdf/PdfPreviewLogin';
import { EpdLinks } from 'routes/EpdRoutes';

const EpdRegistrationCertificatePdfPreview: React.FunctionComponent = () => (
  <PdfPreviewLogin buildAuthRoute={EpdLinks.epdRegistrationCertificatePdfPreviewAuth} />
);

export default EpdRegistrationCertificatePdfPreview;
